import React from 'react';
import './VideoSection.css';

const VideoSection = () => {
  return (
    <div className="video-section-container" id="app-intro-video">
      <div className="video-section-content">
        <div className="video-wrapper">
          <iframe 
            src="https://www.youtube.com/embed/UqLuN6IslDo" 
            title="App Introduction Video" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          ></iframe>
        </div>
        
        {/* Line below the content */}
        <div className="w-full mt-24 flex justify-center">
          <div className="w-full h-[2px] bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>
        </div>
      </div>
    </div>
  );
};

export default VideoSection; 